import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import VueGtag from "vue-gtag"
Vue.use(VueGtag, {
	config: { id: 'UA-93098435-22' }
})

import '@mdi/font/css/materialdesignicons.css' 
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy)

import { LMap, LTileLayer, LControlLayers} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-control-layers', LControlLayers)

//prod wss://lp5uxyqz17.execute-api.eu-central-1.amazonaws.com/api/
//dev wss://ioog7l2cad.execute-api.eu-central-1.amazonaws.com/api/

import VueNativeSock from 'vue-native-websocket'
Vue.use(VueNativeSock, 'wss://lp5uxyqz17.execute-api.eu-central-1.amazonaws.com/api/', {
 	store: store,
 	reconnection: true, // (Boolean) whether to reconnect automatically (false)
  	reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
  	reconnectionDelay: 3000, // (Number) how long to initially wait before attempting a new (1000)
})

import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import aws_exports from './aws-exports.js'
Amplify.configure(aws_exports)
Vue.use(AmplifyPlugin, AmplifyModules)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueMobileDetection from 'vue-mobile-detection'
Vue.use(VueMobileDetection)

Vue.config.productionTip = false

new Vue({
  	store,
  	router,
  	render: h => h(App)
}).$mount('#app')
